const BlopPreviewManager = (() => {
    const trackedWindows = [];

    const previewBase64File = (base64data, contentType, filename, sliceSize = 512) => {
        const base64WithoutPrefix = base64data.substr(
            "data:application/pdf;base64,".length
          );
          const byteCharacters = window.atob(base64WithoutPrefix);
          //const byteCharacters = Buffer.from(base64data, 'base64')
          const byteArrays = [];
        
          for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
        
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
            }
        
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
          }
        
          const blob = new Blob(byteArrays, { type: contentType });
          const blobUrl = URL.createObjectURL(blob);
        
          const newWindow = window.open(blobUrl, filename); //|| window.location.replace(blobUrl);
          if (newWindow === null || typeof newWindow == "undefined") {
            window.alert(
              "Hyväksy ponnahdusikkunat selaimesi asetuksissa nähdäksesi liitteen."
            );
          }
          
          const windowData = { windowRef: newWindow, blobUrl};
          trackedWindows.push(windowData);

          const intervalId = setInterval(() => {
            if (newWindow.closed) {
                clearInterval(intervalId);
                URL.revokeObjectURL(blobUrl);
                removeWindow(windowData);
            }
          }, 10000);
    };

    const removeWindow = (windowData) => {
        const index = trackedWindows.indexOf(windowData);
        if (index !== -1) {
            trackedWindows.splice(index, 1);
        }
    };
    const revokeAll = () => {
        for (const { windowRef, blobUrl} of trackedWindows) {
            if (!windowRef.closed) {
                windowRef.close();
            }
            URL.revokeObjectURL(blobUrl);
        }
        trackedWindows.length = 0;
        console.log("All urls removed");
    };
    return {
        previewBase64File,
        revokeAll
    }
})();

export default BlopPreviewManager;